import { CellProps } from './Grid.interface'
import { FC } from 'react'
import { StyledCell } from './GridCell.styled';

const GridCell: FC<CellProps> = ({ tag = 'div', ...rest }) => (
  <StyledCell as={tag} {...rest} />
)

export default GridCell;
